import parsePhoneNumber from 'libphonenumber-js';

/**
 * Empty when the number parses, otherwise the translation key for why not.
 *
 * Returns a key rather than a message so the caller's namespace words it —
 * `UIPhoneInput` shows it, but the form around it owns the copy.
 */
export function validatePhone(value: string): string {
    try {
        const phoneNumber = parsePhoneNumber(value.trim());
        if (phoneNumber && phoneNumber.isValid()) {
            return '';
        }
        return 'shared.fields.phone.error_invalid';
    } catch {
        return 'shared.fields.phone.error_invalid';
    }
}
